$(document).ready(function(){
   $('.block2-events, .block2-campus, .block2-europe').mouseover(function(){
       $class = $(this).attr('class');
       $type = $class.substring($class.indexOf('-') + 10);
       $('.block3-' + $type).addClass('hover');
   });

    $('.block2-events, .block2-campus, .block2-europe').mouseout(function(){
        $class = $(this).attr('class');
        $type = $class.substring($class.indexOf('-') + 10);
        $('.block3-' + $type).removeClass('hover');
    });

    $('.block2-column').click(function (e){
       window.location = $(this).data('href');
    });

    $('[data-href]').css('pointer','cursor').click(function(){
        var t               = $(this),
            URL             = t.attr('data-href');
        $('<a href="'+ URL +'" target="_blank">External Link</a>')[0].click();

    });
});